export const BetSlipErrorMessages = {
    Unauthenticated: 'BET_SLIP.ERRORS.USER_NOT_AUTHENTICATED',
    ServerError: 'BET_SLIP.ERRORS.SERVER_ERROR',
    InputLessThanOne: 'BET_SLIP.ERRORS.VALUE_LESS_THAN_ONE',
    ValidationError: 'BET_SLIP.ERRORS.VALIDATION_ERROR',
    SlipEmpty: 'BET_SLIP.ERRORS.SLIP_EMPTY'
}

export const OfferAdditionErrors = {
    SystemBetSlipNoMultiOffer: {
        message: "MULTIOFFER_BET_SLIP_TYPE_SYSTEM",
        errorCode: 0
    },
    SameEventMultiOffer: {
        message: "MULTIOFFER_SAME_EVENT_MULTI_OFFER",
        errorCode: 1,
    },
    MultiOfferExists: {
        message: "MULTIOFFER_MULTIOFFER_EXISTS",
        errorCode: 2,
    },
    RegularOfferWithMultiOffer: {
        message: "MULTIOFFER_REGULAR_OFFER_WITH_MULTI_OFFER",
        errorCode: 3,
    },
    MultiOfferWithRegularOffer: {
        message: "MULTIOFFER_MULTI_OFFER_WITH_REGULAR_OFFER",
        errorCode: 4,
    },
    // Case 5
    // When you have a regular offer selected, and you add another offer for the same event, you create something called a "multi" offer event.
    // Not to be confused with "MultiOffer", which is what we call an offer created by BetBuilder.
    EventWithMultipleOffers: {
        message: "MULTIOFFER_EVENT_WITH_MULTIPLE_OFFERS",
        errorCode: 5,
    },
    EventWithMultipleOffersPresent: {
        message: "MULTIOFFER_EVENT_WITH_MULTIPLE_OFFERS_PRESENT",
        errorCode: 6,
    }
}